var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "align-right": _vm.alignRight,
      },
    },
    [
      _vm.columnId === "name"
        ? _c("div", { staticClass: "name" }, [
            _vm._v(" " + _vm._s(_vm.nameString || "–") + " "),
          ])
        : _vm._e(),
      _vm.columnId === "filial"
        ? [_vm._v(" " + _vm._s(_vm.filialString || "–") + " ")]
        : _vm._e(),
      _vm.columnId === "posts"
        ? [_vm._v(" " + _vm._s(_vm.positionsString || "–") + " ")]
        : _vm._e(),
      _vm.columnId === "paytypes"
        ? [_vm._v(" " + _vm._s(_vm.paymentTypesString || "–") + " ")]
        : _vm._e(),
      _vm.columnId === "period"
        ? [_vm._v(" " + _vm._s(_vm.periodString || "–") + " ")]
        : _vm._e(),
      _vm.columnId === "address"
        ? _c(
            _vm.entry.type === "zone" ? "a" : "span",
            {
              tag: "component",
              attrs: { href: _vm.entry.zone.url, target: "_blank" },
            },
            [_vm._v(" " + _vm._s(_vm.addressString) + " ")]
          )
        : _vm._e(),
      _vm.columnId === "coordinates"
        ? [_vm._v(" " + _vm._s(_vm.coordsString || "–") + " ")]
        : _vm._e(),
      _vm.columnId === "distance"
        ? _c(
            "span",
            {
              class: {
                "default-number": !_vm.entry.distance.value,
                "positive-number":
                  _vm.entry.distance.value &&
                  _vm.entry.distance.change === "up",
                "negative-number":
                  _vm.entry.distance.value &&
                  _vm.entry.distance.change === "down",
              },
            },
            [_vm._v(" " + _vm._s(_vm.distanceString) + " ")]
          )
        : _vm._e(),
      _vm.columnId === "price"
        ? _c(
            "span",
            {
              class: {
                "default-number": !_vm.entry.price.value,
                "positive-number":
                  _vm.entry.distance.value && _vm.entry.price.change === "up",
                "negative-number":
                  _vm.entry.distance.value && _vm.entry.price.change === "down",
              },
            },
            [_vm._v(" " + _vm._s(_vm.priceString) + " ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }